/**
 * Невалидный адрес электронной почты при проверке email на доступность
 * @type {string}
 */
export const NO_VALID_EMAIL_AVAILABILITY = 'e1420a46-7bf6-44cf-8723-7e57e4925236';

export const SUCCESS_RECOVERY_BY_PHONE = 'Вам отправлено смс с данными для входа. Вы можете авторизоваться на сайте, используя эти данные.';

export const ERROR_CAPTCHA = Object.freeze({
  notStringCaptchaToken: 'CaptchaToken должен быть строкой',
  emptyCaptchaToken: 'CaptchaToken не должен быть пустым',
  notStringCaptchaAction: 'CaptchaAction должен быть строкой',
  emptyCaptchaAction: 'CaptchaAction не должен быть пустым',
  notStringCaptchaVersion: 'CaptchaVersion должен быть строкой',
  emptyCaptchaVersion: 'CaptchaVersion не должен быть пустым',
});

export const ERROR_USER_SESSION = Object.freeze({
  notLogin: 'Поле Email обязательно для заполнения',
  notStringLogin: 'Поле Email должно быть строкой',
  notPassword: 'Поле пароль обязательно для заполнения',
  notStringPassword: 'Поле пароль должно быть строкой',
  'e1420a46-7bf6-44cf-8723-7e57e4925236': 'Не заполнено поле Email',
  'ec375749-2357-46e3-a746-4a4c65d8d0cb': 'Неверный Email или пароль',
  '5395533f-ca4e-4f4d-bed4-a44656dcd60a': 'Ошибка проверки капчи',
  '74a40299-26ba-42f7-a045-58d548db6f97': 'Ошибка получения информации о пользователе',
});

export const ERROR_USER_SESSION_DELETE = Object.freeze({
  'ec375749-2357-46e3-a746-4a4c65d8d0cb': 'Не получилось выйти',
});

export const ERROR_USER = Object.freeze({
  'b7bfe87d-f04b-4560-b102-5e94ee471e2e': 'Пользователь с таким номером телефона уже зарегистрирован',
});

export const ERROR_USER_UPDATE = Object.freeze({
  '074f064e-decf-48ef-b465-7917f8df808a': 'Пользователь с таким номером телефона уже существует',
  '56d131eb-cd48-4c86-bdc4-155bd30f42ff': 'Пользователь с таким Email уже существует',
  'e1420a46-7bf6-44cf-8723-7e57e4925236': 'Поле Фамилия обязательно для заполнения',
  'ec375749-2357-46e3-a746-4a4c65d8d0cb': 'Нет доступа для обновления пользовательских данных',
});

export const ERROR_USER_PASSWORD_RECOVERY = Object.freeze({
  notLogin: 'Поле Email обязательно для заполнения',
  notStringLogin: 'Поле Email должно быть строкой',
  notPhone: 'Поле Телефон обязательно для заполнения',
  notStringPhone: 'Поле Телефон должно быть строкой',
});

export const ERROR_USER_PASSWORD_CHANGE = Object.freeze({
  notCurPassword: 'Поле Текущий пароль обязательно для заполнения',
  notNewPassword: 'Поле Новый пароль обязательно для заполнения',
  notNewPasswordConfirm: 'Пароли должны совпадать',
});

export const ERROR_CHECK_EMAIL_AVAILABILITY = Object.freeze({
  notEmail: 'Поле Email обязательно для заполнения',
  notStringEmail: 'Поле Email должно быть строкой',
});

export const ERROR_CHECK_USER_PROBLEM = Object.freeze({
  notPhone: 'Поле Телефон обязательно для заполнения',
  notStringPhone: 'Поле Телефон должно быть строкой',
  phoneTooLong: 'Некорректный номер телефона',
  tryLater: 'Попробуйте позже или обратитесь в клиентскую службу',
});

export const ERROR_CALL_ORDER = Object.freeze({
  notStringPhone: 'Поле Телефон должен быть строкой',
  emptyPhone: 'Поле Телефон не должен быть пустым',
});

export const ERROR_USER_AUTHORIZED_BY_HASH = Object.freeze({
  hashUndefined: 'параметр hash отсутствует',
  notStringHash: 'параметр hash должен быть строкой',
});

export const USER_SUBSCRIPTIONS = Object.freeze({
  subscribedAll: 'Вы подписаны на email-рассылки book24.ru',
  unsubscribedAll: 'Вы отписаны от email-рассылок book24.ru',
});
